import './components';
import './scroll-elements';
import fetchival from 'fetchival';
import { debounce } from 'lodash';
import Bouncer from 'formbouncerjs/dist/bouncer.polyfills';
import Micromodal from 'micromodal';
import privacyPolicyPopup from '../../auto/privacyPolicyPopup';

import { setDropdownInteration } from '../../auto/utils/components';
import fetchCached from '../../auto/utils/fetchCached';
import isMobile from '../../auto/utils/isMobile';
import equalHeights from '../../auto/utils/equalHeights';
import hookConversion from '../../auto/utils/hookConversion';
import { createCookieUTM } from '../../auto/utils/utm';
import { createGADCookie } from '../../auto/utils/gadTracking';
import autoServiceApi from '../../auto/utils/autoServiceApi';
import railsDateToChronometer from '../../auto/utils/railsDateToChronometer';
import { renderInteractiveWhatsappForm } from '../../auto/utils/interactiveWhatsappForm';
import { initSectionWhenItIsVisible } from '../../auto/utils/initSectionWhenItIsVisible';
import { initSectionWhenUserInteracts } from '../../auto/utils/initSectionWhenUserInteracts';
import validationFactory from '../../auto/utils/validation';
import maskField, { MASK_TYPES } from '../../auto/utils/maskField';
import proxyEvents from '../../auto/utils/proxyEvents';

import serviceFactory from '../../auto/autoForceServiceFactory';
import serviceConversionFactory from '../../auto/autoBoxOfficeServiceFactory';
import helpers from '../../auto/helpers';

import DDMDataLayerService from '../../auto/services/ddm_data_layer_service/DDMDataLayerService';

import { attachClickEvents } from '../../auto/utils/attachClickEvents';
import { defaultEvents } from '../../auto/services/click_attacher_service/events/jeepEventsConfiguration';

require('bootstrap.native/dist/bootstrap-native-v4');

window.matchHeight = {
  match: equalHeights,
};
window.MASK_TYPES = MASK_TYPES;
window.maskField = maskField;

window.helpers = helpers;
window.isMobile = isMobile;
window.Bouncer = Bouncer;
window.validationFactory = validationFactory;

window.fetchCached = fetchCached;
window.fetchival = fetchival;
window.Micromodal = Micromodal;

window.autoServiceApi = autoServiceApi;
window.hookConversion = hookConversion;
window.railsDateToChronometer = railsDateToChronometer;
window.renderInteractiveWhatsappForm = renderInteractiveWhatsappForm;
window.debounce = debounce;

window.service = serviceFactory();
window.serviceConversion = serviceConversionFactory();

window.DDMDataLayerService = new DDMDataLayerService();

createCookieUTM();
createGADCookie();

window.whatsappDidUpdate = function () {};

window.helpers = {
  ...window.helpers,
  initSectionWhenItIsVisible,
  initSectionWhenUserInteracts,
};

window.components = {
  setDropdownInteration,
};

$(document).on('click', proxyEvents);

window.privacyPolicyPopup = privacyPolicyPopup;

window.attachClickEvents = attachClickEvents;
window.attachClickEvents(window.DDMDataLayerService, [...defaultEvents]);
